import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Param } from '../../../model/common/param';
import { EmployeeHttpService } from '../../../services/http/administration/employee.http.service';
import { PartnerHttpService } from '../../../services/http/documents/partner.http.service';
import { Employee } from '../../../model/api/administration/employee';
import { Partner } from '../../../model/api/documents/partner';
import { TypeList } from '../types/type.list';
import { SubTypeList } from '../sub-types/sub-type.list';
import { AccountList } from '../account/account.list';
import { OrderOpDetailList } from '../order-ops/order-op.detail.list';
import { OfferList } from '../offer/offer.list';
import { BudgetList } from '../budget/budget.list';
import { AdministrationHttpService } from '../../../services/http/administration/administration.http.service';
import { CostCenterHttpService } from '../../../services/http/administration/cost-center.http.service';
import { MasterTypeHttpService } from '../../../services/http/assets/master-type.http.service';
import { TypeHttpService } from '../../../services/http/administration/type.http.service';
import { SubTypeHttpService } from '../../../services/http/administration/sub-type.http.service';
import { EntityFileHttpService } from '../../../services/http/common/entity-file.http.service';
import { AccMonthHttpService } from '../../../services/http/accounting/acc-month.http.service';
import { AccountHttpService } from '../../../services/http/administration/account.http.service';
import { OrderOpHttpService } from '../../../services/http/administration/order-op.http.service';
import { MasterTypeListComponent } from '../../assets/master-types/master-type.list';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EmployeeListComponent } from '../employees/employee.list';
import { AccMonthListComponent } from '../../accounting/acc-month.list';
import { PartnerListComponent } from '../../documents/partners/partner.list';
import { UomListComponent } from '../../assets/uoms/uom.list';
import { CostCenterListComponent } from '../cost-centers/cost-center.list';
import { AdministrationListComponent } from '../administrations/administration.list';
import { CompanyListComponent } from '../../assets/companies/company.list';
import { ProjectList } from '../../assets/projects/project.list';
import { InterCompanyListComponent } from '../../assets/inter-companies/inter-company.list';
import { EntityFileListComponent } from '../../common/entity-file.list';
import { EntityFile } from '../../../model/api/common/entity-file';
import { OrderSave } from '../../../model/api/administration/order-save';
import { CodeNameEntity } from '../../../model/api/common/code-name-entity';
import { EmployeeResource } from '../../../model/api/administration/employee-resource';
import { MonthEntity } from '../../../model/api/common/month-entity';
import { Offer } from '../../../model/api/administration/offer';
import { Budget } from '../../../model/api/administration/budget';
import { CodePartnerEntity } from '../../../model/api/common/code-partner-entity';
import { OrderHttpService } from '../../../services/http/administration/order.http.service';
import { AppData } from '../../../app-data';
import { ProjectHttpService } from '../../../services/http/assets/project.http.service';
import { CompanyHttpService } from '../../../services/http/assets/company.http.service';
import { OfferHttpService } from '../../../services/http/administration/offer.http.service';
import { BudgetHttpService } from '../../../services/http/administration/budget.http.service';
import { InterCompanyHttpService } from '../../../services/http/assets/inter-company.http.service';
import { UomHttpService } from '../../../services/http/assets/uom.http.service';
import { MasterType } from '../../../model/api/assets/master-type';
import { Type } from '../../../model/api/administration/type';
import { SubType } from '../../../model/api/administration/sub-type';
import { Administration } from '../../../model/api/administration/administration';
import { Company } from '../../../model/api/assets/company';
import { Project } from '../../../model/api/assets/project';
import { InterCompany } from '../../../model/api/assets/inter-company';
import { AccMonth } from '../../../model/api/accounting/acc-month';
import { CostCenter } from '../../../model/api/administration/cost-center';
import { Account } from '../../../model/api/administration/account';
import { Uom } from '../../../model/api/assets/uom';
import { AppConfig } from '../../../config';


@Component({
    selector: 'order-detail-ui',
    templateUrl: 'order.detail.ui.html',
    styleUrls: ['order.detail.ui.scss'],
    providers: [
        AdministrationHttpService,
        CostCenterHttpService,
        MasterTypeHttpService,
        TypeHttpService,
        SubTypeHttpService,
        EntityFileHttpService,
        EmployeeHttpService,
        AccMonthHttpService,
        AccountHttpService,
        OrderOpHttpService,
        PartnerHttpService ]
})
export class OrderDetailUI  {

    @ViewChild('masterTypeList') public masterTypeList: MasterTypeListComponent;
    @ViewChild('masterTypeListModal') public masterTypeListModal: ModalDirective;

    @ViewChild('typeList') public typeList: TypeList;
    @ViewChild('typeListModal') public typeListModal: ModalDirective;

    @ViewChild('subTypeList') public subTypeList: SubTypeList;
    @ViewChild('subTypeListModal') public subTypeListModal: ModalDirective;

    @ViewChild('employeeList') public employeeList: EmployeeListComponent;
    @ViewChild('employeeListModal') public employeeListModal: ModalDirective;

    @ViewChild('accMonthList') public accMonthList: AccMonthListComponent;
    @ViewChild('accMonthListModal') public accMonthListModal: ModalDirective;

    @ViewChild('partnerList') public partnerList: PartnerListComponent;
    @ViewChild('partnerListModal') public partnerListModal: ModalDirective;

    @ViewChild('uomList') public uomList: UomListComponent;
    @ViewChild('uomListModal') public uomListModal: ModalDirective;

    @ViewChild('accountList') public accountList: AccountList;
    @ViewChild('accountListModal') public accountListModal: ModalDirective;

    @ViewChild('costCenterList') public costCenterList: CostCenterListComponent;
    @ViewChild('costCenterListModal') public costCenterListModal: ModalDirective;

    @ViewChild('administrationList') public administrationList: AdministrationListComponent;
    @ViewChild('administrationListModal') public administrationListModal: ModalDirective;

    @ViewChild('companyList') public companyList: CompanyListComponent;
    @ViewChild('companyListModal') public companyListModal: ModalDirective;

    @ViewChild('offerList') public offerList: OfferList;
    @ViewChild('offerListModal') public offerListModal: ModalDirective;

    @ViewChild('budgetList') public budgetList: BudgetList;
    @ViewChild('budgetListModal') public budgetListModal: ModalDirective;

    @ViewChild('projectList') public projectList: ProjectList;
    @ViewChild('projectListModal') public projectListModal: ModalDirective;

    @ViewChild('interCompanyList') public interCompanyList: InterCompanyListComponent;
    @ViewChild('interCompanyListModal') public interCompanyListModal: ModalDirective;

    @ViewChild('orderOpDetailList') public orderOpList: OrderOpDetailList;
    @ViewChild('entityFileList') public entityFileList: EntityFileListComponent;

    @ViewChild('confirmationModal') public confirmationModal: ModalDirective;
    @ViewChild('fileInput') fileInput;

    public entityTypeCode: string = 'ORDER';
    public entityFile: EntityFile = null;
    public confirmationMessage: string = '';
    public operationType: OperationType = OperationType.NotSet;


    public id: number = 0;
    public order: OrderSave = new OrderSave();
    public filesToUpload: Array<File>;
    public selectedAssetOp: any;
    public isSaved: boolean = true;

    // public quantityRemBudget = 0;
    public valueRemBudget = 0;
    public isInvalidQuantity = false;
    public isInvalidValue = false;

    public get allowSaving(): boolean {
        return this.order != null &&
        this.order.name != null && this.order.name.trim().length > 3 &&
        (this.order.quantity > 0 && !this.isInvalidQuantity)  &&
        this.order.price > 0 &&
        this.uom != null &&
        this.offer != null &&
        this.budget != null &&
        (this.order.valueIni > 0  && !this.isInvalidValue) &&
        (!this.isInvalidValue && !this.isInvalidQuantity)
    }

    public costCenter: CodeNameEntity = null;
    public employee: EmployeeResource = null;
    public accMonth: MonthEntity = null;
    public company: CodeNameEntity = null;
    public offer: Offer = null;
    public budget: Budget = null;
    public account: CodeNameEntity = null;
    public partner: CodePartnerEntity = null;
    public uom: CodeNameEntity = null;
    public masterType: CodeNameEntity = null;
    public project: CodeNameEntity = null;
    public interCompany: CodeNameEntity = null;
    public type: CodeNameEntity = null;
    public subType: CodeNameEntity = null;
    public administration: CodeNameEntity = null;

    public readOnlyForm: boolean = false;
    public get isAdmin(): boolean { return AppData.UserIsAdmin; }

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public orderHttpService: OrderHttpService,
        public masterTypeHttpService: MasterTypeHttpService,
        public accountHttpService: AccountHttpService,
        public typeHttpService: TypeHttpService,
        public subTypeHttpService: SubTypeHttpService,
        public accMonthHttpService: AccMonthHttpService,
        public employeeHttpService: EmployeeHttpService,
        public costCenterHttpService: CostCenterHttpService,
        public projectHttpService: ProjectHttpService,
        public companyHttpService: CompanyHttpService,
        public offerHttpService: OfferHttpService,
        public budgetHttpService: BudgetHttpService,
        public interCompanyHttpService: InterCompanyHttpService,
        public orderOpHttpService: OrderOpHttpService,
        public partnerHttpService: PartnerHttpService,
        public uomHttpService: UomHttpService,
        public administrationHttpService: AdministrationHttpService,
        public entityFileHttpService: EntityFileHttpService) {
        this.route.params.subscribe((params: Params) => {
            if (params['id']) {
                this.id = +params['id'];
            }
        });
    }

    ngAfterViewInit() {
        // if ((this.assetFullDetail !== null) && (this.assetFullDetail.id === 0)) this.refreshDocumentTypes();
        if (this.id > 0) {
            this.orderHttpService.getDetailById(this.id)
                .subscribe((asset: any) => {
                    // this.asset = asset;
                       this.updateDetails(asset);

                    if (asset.validated) {
                        this.refreshAssetOperations();
                        this.refreshEntityFiles();
                    }
                    else {
                       // this.refreshAssetTypes();
                       // this.refreshDocumentTypes();
                    }
                });
        }
    }

    public refreshEntityFiles(){
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('entityTypeCode', 'ASSET'));
        params.push(new Param('entityId', this.order.id.toString()));

        this.entityFileList.refresh(params);
    }

    public refreshAssetOperations(){
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('assetId', this.id.toString()));
        this.orderOpList.refresh(params);
    }

    public updateDetails(order: any) {
        this.order.id = order.id;
        this.order.code = order.code;
        this.order.name = order.name;
        this.order.companyId = order.companyId;
        this.order.offerId = order.offerId;
        this.order.projectId = order.projectId;
        this.order.administrationId = order.administrationId;
        this.order.masterTypeId = order.masterTypeId;
        this.order.typeId = order.typeId;
        this.order.subTypeId = order.subTypeId;
        this.order.employeeId = order.employeeId;
        this.order.accMonthId = order.accMonthId;
        this.order.interCompanyId = order.interCompanyId;
        this.order.partnerId = order.partnerId;
        this.order.uomId = order.uomId;
        this.order.accountId = order.accountId;
        this.order.costCenterId = order.costCenterId;
        this.order.valueIni = order.valueIni;
        this.order.valueFin = order.valueFin;
        this.order.quantity = order.quantity;
        this.order.info = order.info;
        this.order.price = order.price;
        this.order.validated = order.validated;

        this.company = order.company;
        this.offer = order.offer;
        this.budget = order.budget;
        this.project = order.project;
        this.administration = order.administration;
        this.masterType = order.masterType;
        this.type = order.type;
        this.subType = order.subType;
        this.employee = order.employee;
        this.accMonth = order.accMonth;
        this.interCompany = order.interCompany;
        this.partner = order.partner;
        this.account = order.account;
        this.costCenter = order.costCenter;
        this.uom = order.uom;

        // this.quantityRemBudget = order.budget.quantityRem;
        this.valueRemBudget = order.budget.valueFin;
    }

           /*begin MASTERTYPE */
           public selectMasterType() {

            this.masterTypeList.refresh(null);
            this.masterTypeListModal.show();
        }

        public setSelectedMasterType() {
            let items: Array<MasterType> = this.masterTypeList.selectedItems;
            this.masterType = ((items != null) && (items.length === 1)) ? items[0] : null;
            this.masterTypeListModal.hide();
        }

        /*end MASTERTYPE */

          /*begin TYPE */
          public selectType() {

            let params = new Array<Param>();

            params.push(new Param('masterTypeIds', this.masterType != null ? this.masterType.id.toString() : null));

            this.typeList.refresh(params);
            this.typeListModal.show();
        }
        public setSelectedType() {
            let items: Array<Type> = this.typeList.selectedItems;
            this.type = ((items != null) && (items.length === 1)) ? items[0] : null;
            this.typeListModal.hide();
        }

        /*end TYPE */

          /*begin SUBTYPE */
          public selectSubType() {

            let params = new Array<Param>();

            params.push(new Param('typeIds', this.type != null ? this.type.id.toString() : null));


            this.subTypeList.refresh(params);
            this.subTypeListModal.show();
        }
        public setSelectedSubType() {
            let items: Array<SubType> = this.subTypeList.selectedItems;
            this.subType = ((items != null) && (items.length === 1)) ? items[0] : null;
            this.subTypeListModal.hide();
        }

        /*end asset type*/

               /*begin ADMINISTRATION */
               public selectAdministration() {

                this.administrationList.refresh(null);
                this.administrationListModal.show();
            }
            public setSelectedAdministration() {
                let items: Array<Administration> = this.administrationList.selectedItems;
                this.administration = ((items != null) && (items.length === 1)) ? items[0] : null;
                this.administrationListModal.hide();
            }

            /*end ASSETNATURE *


               /*begin COMPANY */
               public selectCompany() {

                this.companyList.refresh(null);
                this.companyListModal.show();
            }
            public setSelectedCompany() {
                let items: Array<Company> = this.companyList.selectedItems;
                this.company = ((items != null) && (items.length === 1)) ? items[0] : null;
                this.companyListModal.hide();
            }

            /*end COMPANY */


               /*begin OFFER */
               public selectOffer() {

                this.offerList.refresh(null);
                this.offerListModal.show();
            }
            public setSelectedOffer() {
                let items: Array<Offer> = this.offerList.selectedItems;
                this.offer = ((items != null) && (items.length === 1)) ? items[0] : null;
                this.offerListModal.hide();
            }

            /*end OFFER */

              /*begin BUDGET */
              public selectBudget() {

                this.budgetList.refresh(null);
                this.budgetListModal.show();
            }
            public setSelectedBudget() {
                let items: Array<Budget> = this.budgetList.selectedItems;
                this.budget = ((items != null) && (items.length === 1)) ? items[0] : null;

                if (this.budget != null) {
                  // this.quantityRemBudget = this.budget.quantityRem;
                  this.valueRemBudget = this.budget.valueFin;
                }

                this.budgetListModal.hide();
            }

            /*end BUDGET */

               /*begin PROJECT */
               public selectProject() {

                this.projectList.refresh(null);
                this.projectListModal.show();
            }
            public setSelectedProject() {
                let items: Array<Project> = this.projectList.selectedItems;
                this.project = ((items != null) && (items.length === 1)) ? items[0] : null;
                this.projectListModal.hide();
            }

            /*end PROJECT */

               /*begin INTERCOMPANY */
               public selectInterCompany() {

                let params = new Array<Param>();

                params.push(new Param('partnerIds', this.partner != null ? this.partner.id.toString() : null));

                this.interCompanyList.refresh(null);
                this.interCompanyListModal.show();
            }
            public setSelectedInterCompany() {
                let items: Array<InterCompany> = this.interCompanyList.selectedItems;
                this.interCompany = ((items != null) && (items.length === 1)) ? items[0] : null;
                this.interCompanyListModal.hide();
            }

            /*end INTERCOMPANY */

    /*begin employee*/
    public selectEmployee() {
        this.employeeList.refresh(null);
        this.employeeListModal.show();
    }

    public setSelectedEmployee() {
        let items: Array<Employee> = this.employeeList.selectedItems;
        this.employee = ((items != null) && (items.length === 1)) ? items[0] : null;
        this.employeeListModal.hide();
    }
    /*end employee*/

     /*begin AccMonth*/
     public selectAccMonth() {
        this.accMonthList.refresh(null);
        this.accMonthListModal.show();
    }

    public setSelectedAccMonth() {
        let items: Array<AccMonth> = this.accMonthList.selectedItems;
        this.accMonth = ((items != null) && (items.length === 1)) ? items[0] : null;
        this.accMonthListModal.hide();
    }
    /*end AccMonth */


        /* begin costcenter */
        public selectCostCenter() {

            this.costCenterList.refresh(null);
            this.costCenterListModal.show();
        }
        public setSelectedCostCenter() {
            let items: Array<CostCenter> = this.costCenterList.selectedItems;
            this.costCenter = ((items != null) && (items.length === 1)) ? items[0] : null;
            this.costCenterListModal.hide();
        }
        /*end costcenter */

    /*begin partner*/
    public selectPartner() {
        this.partnerList.refresh(null);
        this.partnerListModal.show();
    }

    public setSelectedPartner() {
        let items: Array<Partner> = this.partnerList.selectedItems;
         this.partner = ((items != null) && (items.length === 1)) ? items[0] : null;
        this.partnerListModal.hide();
    }

    /*end UOM*/

        /*begin partner*/
        public selectUom() {
          this.uomList.refresh(null);
          this.uomListModal.show();
      }

      public setSelectedUom() {
          let items: Array<Uom> = this.uomList.selectedItems;
           this.uom = ((items != null) && (items.length === 1)) ? items[0] : null;
          this.uomListModal.hide();
      }

      /*end UOM*/


        /*begin Account*/
        public selectAccount() {
            this.accountList.refresh(null);
            this.accountListModal.show();
        }

        public setSelectedAccount() {
            let items: Array<Account> = this.accountList.selectedItems;
             this.account = ((items != null) && (items.length === 1)) ? items[0] : null;
            this.accountListModal.hide();
        }

        /*end Account*/


     public cancelChanges() {
        // this.ngLocation.back();
        this.router.navigate(['/order'])
    }

    public onDeleteAsset() {
        this.operationType = OperationType.Delete;
        this.confirmationMessage = 'Stergeti inregistrarea curenta?';
        this.confirmationModal.show();
    }

    public deleteAsset() {
        this.orderHttpService.delete(this.order.id)
            .subscribe(() => this.router.navigate(['/assetdepdetails']));
    }

    public onValidateAsset() {
        this.operationType = OperationType.AssetValidation;
        this.confirmationMessage = 'Validati inregistrarea curenta?';
        this.confirmationModal.show();
    }

    public validateBudget() {
        this.order.validated = true;
        this.saveOrder();
    }

    public addNewOperation() {
        // let assets: Array<AssetSimpleDetail> = new Array<AssetSimpleDetail>();
        // assets.push(new AssetSimpleDetail(this.asset.id, this.asset.invNo, this.asset.assetName,
        //     '', this.asset.partner, this.asset.assetType, this.asset.accState, this.asset.usageStartDate, '', ''));
        // AppData.AssetList = assets;
        // this.router.navigate(['/newoperation']);
    }


    public saveOrder() {

      if (this.isInvalidQuantity || this.isInvalidValue) {
        alert('Va rugam sa refaceti cantitatile si valorile!');
      } else {
        this.isSaved = false;

        this.order.companyId = this.company != null ? this.company.id : null;
        this.order.offerId = this.offer != null ? this.offer.id : null;
        this.order.budgetId = this.budget != null ? this.budget.id : null;
        this.order.projectId = this.project != null ? this.project.id : null;
        this.order.administrationId = this.administration != null ? this.administration.id : null;
        this.order.masterTypeId = this.masterType != null ? this.masterType.id : null;
        this.order.typeId = this.type != null ? this.type.id : null;
        this.order.subTypeId = this.subType != null ? this.subType.id : null;
        this.order.employeeId = this.employee != null ? this.employee.id : null;
        this.order.accMonthId = this.accMonth != null ? this.accMonth.id : null;
        this.order.interCompanyId = this.interCompany != null ? this.interCompany.id : null;
        this.order.partnerId = this.partner != null ? this.partner.id : null;
        this.order.uomId = this.uom != null ? this.uom.id : null;
        this.order.accountId = this.account != null ? this.account.id : null;
        this.order.costCenterId = this.costCenter != null ? this.costCenter.id : null;


        this.order.validated = true;

        if (this.order.id > 0) {
             this.orderHttpService.updateAsset(this.order)
            .subscribe(() => {
                this.orderHttpService.getDetailById(this.order.id)
                    .subscribe((asset: any) => {
                        if (asset != null) {
                            alert('Datele au fost modificate cu succes!');
                            this.isSaved = true;
                            this.updateDetails(asset);
                            this.refreshAssetOperations();
                        }
                    }, (error) => {
                        alert('Erosre la salvarea datelor!');
                    });
            }, (error) => {
                alert('Eroare server!');
            });
        } else {

            this.orderHttpService.addNewBudget(this.order)
            .subscribe((assetId: number) => {
                if (assetId > 0){
                    alert('Datele au fost salvate!');
                    this.router.navigate(['/order', assetId]);
                    this.id = assetId;
                    this.refreshAssetOperations();
                }
        });
        }
      }

    }

    public onConfirmationApproved() {

        switch (this.operationType) {
            case OperationType.AssetValidation:
                this.validateBudget();
                break;
            case OperationType.Delete:
                this.deleteAsset();
                break;
            case OperationType.ProcessAssetOp:
                this.processAssetOp();
                break;
            default:
                break;
        }

        this.operationType = OperationType.NotSet;
        this.confirmationModal.hide();
    }

    public onConfirmationCanceled() {
        this.operationType = OperationType.NotSet;
        this.confirmationModal.hide();
    }

    public onAssetOpDetailListSelectionChanged(assetOpDetails: Array<any>) {
        this.selectedAssetOp = this.orderOpList.selectedItem;
    }

    public onEntityFileListSelectionChanged(entityFiles: Array<EntityFile>) {
        this.entityFile = ((entityFiles != null) && (entityFiles.length === 1)) ? entityFiles[0] : null;
    }

    public showReport() {
        let reportType: string = '';
        let validReport: boolean = false;

        if (this.selectedAssetOp != null) {
           console.log('TIP DOCUMENT: ', this.selectedAssetOp.documentType.code);
            // switch(this.selectedAssetOp.documentTypeCode) {
                switch(this.selectedAssetOp.documentType.code) {
                case AppConfig.DOCUMENT_TYPE_TRANSFER:
                    reportType = 'movementproviding';
                    validReport = true;
                    break;
                case AppConfig.DOCUMENT_TYPE_CASS:
                    reportType = 'annulement';
                    validReport = true;
                    break;
                case AppConfig.DOCUMENT_TYPE_INVENTORY:
                    reportType = 'movementproviding';
                    validReport = true;
                    break;
                default:
                    break;
            }

            if (validReport) {
                // window.open(`${AppConfig.reportingServer}Report.aspx/?report=${reportType}&documentId=${this.selectedAssetOp.documentId}`);
               console.log(this.selectedAssetOp);
                if (AppConfig.DOCUMENT_TYPE_INVENTORY) {
                    window.open(`${AppConfig.reportingServer}Report.aspx/?report=${reportType}&documentId=${this.selectedAssetOp.document.id}&assetOpId=${this.selectedAssetOp.id}`);
                }else{
                    window.open(`${AppConfig.reportingServer}Report.aspx/?report=${reportType}&documentId=${this.selectedAssetOp.document.id}`);
                }
            }
        }
    }

    public parseDate(dateString: string): Date {
        if (dateString) {
            return new Date(dateString);
        } else {
            return null;
        }
    }

    public onProcessAssetOp() {
        this.operationType = OperationType.ProcessAssetOp;
        this.confirmationMessage = 'Procesati operatia selectata?';
        this.confirmationModal.show();
    }

    public processAssetOp() {
        this.orderOpHttpService.process(this.orderOpList.selectedItem.id).subscribe((data) => {
            this.refreshAssetOperations();
        });
    }

    public onChangeQuantity(event: any): void {
      // this.isInvalidQuantity = this.order.quantity > this.quantityRemBudget;
      this.order.valueIni = this.order.price * this.order.quantity;
      this.onChangeValue(event);
  }

  public onChangeValue(event: any): void {
    this.order.valueIni = this.order.price * this.order.quantity;
    this.isInvalidValue = this.order.valueIni > this.valueRemBudget;
}

public onChangePrice(event: any): void {
// alert(this.order.price * this.order.quantity);
  this.order.valueIni = this.order.price * this.order.quantity;
  this.onChangeValue(event);
}
}

enum OperationType {
    NotSet = 1,
    AssetValidation = 2,
    Delete = 3,
    ProcessAssetOp = 4
}
